// extracted by mini-css-extract-plugin
export default {"contents":"iF-z","sectionHeading":"jF-z"};